import { MarkExtension } from 'remirror';
export default class TextStyleExtension extends MarkExtension {
  static disableExtraAttributes = true; // ✅ Prevents Remirror from enforcing extra attributes
  get name() {
    return 'textStyle';
  }
  createMarkSpec() {
    return {
      attrs: { class: { default: '' } }, // ✅ Ensures a default attribute value
      parseDOM: [
        {
          tag: 'span',
          getAttrs: (dom) => ({
            class: dom.getAttribute('class') || '',
          }),
        },
      ],
      toDOM: (mark) => ['span', { class: mark.attrs.class }, 0],
    };
  }
}
